import React, {  } from 'react';
import { Typo, Bx, Link } from '@curry-group/mui-curcuma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

interface INewsAlertProps {
  headline?: string;
}

export const NewsAlert: React.FunctionComponent<INewsAlertProps> = () => {
  return (
    <Bx mb={1}>
      <Bx display="flex"
        style={{
          border: '1px solid transparent',
          borderRadius: 16,
          background:'rgb(230, 245, 251)',
          padding:'16px'
        }}
      >
        <Bx pr={2}>
          <Typo variant="h1" component="p">
            <FontAwesomeIcon
              icon={faInfoCircle}
              color="white"
              style={{backgroundColor:'#004B76', borderRadius:'50%', cursor:'pointer', fontSize:'1.8rem'}}
            />
          </Typo>
        </Bx>
        <Bx>
          <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
            Pflegen Sie die Interessen in Ihrem 
            &nbsp;
            <Link color={'primary'}
              to={'/user/profile?ref=/news'}
              title={'Interessen im Profil pflegen'}
            >
              Profil
            </Link>
            ,&nbsp;
            um personalisierte News angezeigt zu bekommen. Eine News wird 30 Tage im Newsticker angezeigt.
          </Typo>
        </Bx>
      </Bx>
    </Bx>
  );
};
